// Shared Google Maps loader utility
// Ensures only one Loader instance is created and reused across components
import { Loader } from '@googlemaps/js-api-loader'

let loaderInstance = null
let googleInstance = null

/**
 * Get or create the Google Maps Loader instance
 * @param {string} apiKey - Google Maps API key
 * @returns {Loader} - Shared Loader instance
 */
export function getLoader(apiKey) {
  if (!loaderInstance) {
    loaderInstance = new Loader({
      apiKey,
      version: 'weekly'
    })
  }
  return loaderInstance
}

/**
 * Load Google Maps and return the google object
 * @param {string} apiKey - Google Maps API key
 * @returns {Promise<google>} - Google Maps instance
 */
export async function loadGoogleMaps(apiKey) {
  if (googleInstance) {
    return googleInstance
  }

  const loader = getLoader(apiKey)
  googleInstance = await loader.load()
  return googleInstance
}

/**
 * Load the Places library
 * @param {string} apiKey - Google Maps API key
 * @returns {Promise<{Autocomplete: any}>} - Places library
 */
export async function loadPlacesLibrary(apiKey) {
  const google = await loadGoogleMaps(apiKey)
  return google.maps.importLibrary('places')
}
